import { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

const decodeIsAdmin = (token) => {
  try {
    const base64url = token.split('.')[1]
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/').padEnd(
      Math.ceil(base64url.length / 4) * 4, '='
    )
    return JSON.parse(atob(base64)).isAdmin === true
  } catch {
    return false
  }
}

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Store admin session

  useEffect(() => {
    // Check local storage for a logged-in user
    const storedUser = localStorage.getItem("adminUser");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      // Always derive isAdmin from the signed token — never trust the stored value
      setUser({ ...parsed, isAdmin: decodeIsAdmin(parsed.token) });
    }
  }, []);

  const login = (adminData) => {
    setUser(adminData);
    localStorage.setItem("adminUser", JSON.stringify(adminData)); // Persist login
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("adminUser"); // Remove session
  };

  return (
    <AppContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
